//
// Copyright (C) 2025 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/GetSupportedValuesListsTypes.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PropIdAreaId } from "./PropIdAreaId_pb";
import { file_android_hardware_automotive_vehicle_PropIdAreaId } from "./PropIdAreaId_pb";
import type { RawPropValues } from "./RawPropValues_pb";
import { file_android_hardware_automotive_vehicle_RawPropValues } from "./RawPropValues_pb";
import type { StatusCode } from "./StatusCode_pb";
import { file_android_hardware_automotive_vehicle_StatusCode } from "./StatusCode_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/GetSupportedValuesListsTypes.proto.
 */
export const file_android_hardware_automotive_vehicle_GetSupportedValuesListsTypes: GenFile = /*@__PURE__*/
  fileDesc("CkZhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9HZXRTdXBwb3J0ZWRWYWx1ZXNMaXN0c1R5cGVzLnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byK7AQoZU3VwcG9ydGVkVmFsdWVzTGlzdFJlc3VsdBJFCgZzdGF0dXMYASABKA4yNS5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5TdGF0dXNDb2RlElcKFXN1cHBvcnRlZF92YWx1ZXNfbGlzdBgCIAMoCzI4LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlJhd1Byb3BWYWx1ZXMicgoeR2V0U3VwcG9ydGVkVmFsdWVzTGlzdHNSZXF1ZXN0ElAKD3Byb3BfaWRfYXJlYV9pZBgBIAMoCzI3LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlByb3BJZEFyZWFJZCJ1Ch1HZXRTdXBwb3J0ZWRWYWx1ZXNMaXN0c1Jlc3VsdBJUCgZyZXN1bHQYASADKAsyRC5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5TdXBwb3J0ZWRWYWx1ZXNMaXN0UmVzdWx0YgZwcm90bzM", [file_android_hardware_automotive_vehicle_PropIdAreaId, file_android_hardware_automotive_vehicle_RawPropValues, file_android_hardware_automotive_vehicle_StatusCode]);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.SupportedValuesListResult
 */
export type SupportedValuesListResult = Message<"android.hardware.automotive.vehicle.proto.SupportedValuesListResult"> & {
  /**
   * *
   * The status for result. If this is not OK, the operation failed for this
   * [propId, areaId].
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.StatusCode status = 1;
   */
  status: StatusCode;

  /**
   * *
   * The supported values list.
   *
   * If the [propId, areaId] does not specify a supported values list, this
   * is {@code null}.
   *
   * This must be ignored if status is not {@code StatusCode.OK}.
   *
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.RawPropValues supported_values_list = 2;
   */
  supportedValuesList: RawPropValues[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.SupportedValuesListResult.
 * Use `create(SupportedValuesListResultSchema)` to create a new message.
 */
export const SupportedValuesListResultSchema: GenMessage<SupportedValuesListResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_GetSupportedValuesListsTypes, 0);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.GetSupportedValuesListsRequest
 */
export type GetSupportedValuesListsRequest = Message<"android.hardware.automotive.vehicle.proto.GetSupportedValuesListsRequest"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.PropIdAreaId prop_id_area_id = 1;
   */
  propIdAreaId: PropIdAreaId[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.GetSupportedValuesListsRequest.
 * Use `create(GetSupportedValuesListsRequestSchema)` to create a new message.
 */
export const GetSupportedValuesListsRequestSchema: GenMessage<GetSupportedValuesListsRequest> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_GetSupportedValuesListsTypes, 1);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.GetSupportedValuesListsResult
 */
export type GetSupportedValuesListsResult = Message<"android.hardware.automotive.vehicle.proto.GetSupportedValuesListsResult"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.SupportedValuesListResult result = 1;
   */
  result: SupportedValuesListResult[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.GetSupportedValuesListsResult.
 * Use `create(GetSupportedValuesListsResultSchema)` to create a new message.
 */
export const GetSupportedValuesListsResultSchema: GenMessage<GetSupportedValuesListsResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_GetSupportedValuesListsTypes, 2);

